
(function () {
  'use strict';

  var routes = (window.themeVariables && window.themeVariables.routes) || {};
  var CART_URL = routes.cartUrl || '/cart';
  var ADD_URL = routes.cartAddUrl || CART_URL + '/add';
  var CHANGE_URL = routes.cartChangeUrl || CART_URL + '/change';

  // How long to wait after the last tap before writing the coalesced quantity.
  var WRITE_DELAY = 320;

  var cart = null;
  var quantities={};
  var subscribers = [];
  var reconciled = false;

  // True until a fresh /cart.js has landed, and again whenever a write left us
  // unsure what the server holds. A write never computes its delta from a stale cart.
  var stale = true;

  function setCart(nextCart){
    cart=nextCart;
    stale=false;
    quantities={};

    nextCart.items.forEach(function(item){
      var hidden=Object.keys(item.properties||{}).some(function(key){
        return key.charAt(0)==='_';
      });
      if(!hidden){
        quantities[item.variant_id] = (quantities[item.variant_id] || 0) + item.quantity;
      }
    });

    publish();
  }

  function publish() {
    for (var i = 0; i < subscribers.length; i++) {
      try {
        subscribers[i]();
      } catch (error) {
        console.error('[card-qty-stepper]', error);
      }
    }
  }

  function ingest(nextCart) {
    // announce() already published this exact object before re-dispatching it.
    if (!nextCart || !nextCart.items || nextCart === cart) return;

    setCart(nextCart);
  }

  function fetchCart() {
    return fetch(CART_URL + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(
      function (response) {
        if (!response.ok) {
          throw new Error('Could not read the cart');
        }

        return response.json();
      }
    );
  }

  document.documentElement.addEventListener('cart:updated', function (event) {
    ingest(event.detail && event.detail.cart);
  });

  document.documentElement.addEventListener('cart:refresh', function (event) {
    ingest(event.detail && event.detail.cart);
  });


  /* Drawer suppression for adds made from a stepper's own add to cart button.
   *
   * The stepper appearing is the add's confirmation, so the drawer stays shut.
   * Each successful stepper add books one suppression, and the next cart:refresh
   * that asks to open the drawer spends it.
   *
   * Booked on variant:added, not on submit. The theme's ProductForm dispatches
   * it on the form only when /cart/add.js succeeded, and always before it
   * fetches /cart.js and dispatches that add's cart:refresh. So a failed add
   * books nothing, and a slow network can't outrun the booking.
   *
   * Spent only by a refresh that asks to open the drawer. Refreshes that don't
   * (stepper +/-, the pageshow refresh in js-variables, GoKwik, drawer coupons)
   * leave it alone, and two adds in flight each get their own booking. The old
   * single 5s timestamp failed on all three counts.
   *
   * The TTL only clears a booking whose refresh never arrived.
   */
  // var SUPPRESS_TTL = 30000;
  // var suppressions = [];

  // document.addEventListener(
  //   'variant:added',
  //   function (event) {
  //     var form = event.target;
  //     var stepper = form && form.closest ? form.closest('card-qty-stepper') : null;

  //     if (!stepper) return;

  //     // A pack add (pack-mode) keeps the button instead, so let the drawer open.
  //     if (stepper.hasAttribute('pack-mode')) return;

  //     // Mirror the theme's own openMiniCart condition. Where it would not open
  //     // the drawer anyway, a booking would never be spent and would linger.
  //     var settings = (window.themeVariables && window.themeVariables.settings) || {};
  //     if (settings.cartType !== 'drawer' || form.closest('.drawer')) return;

  //     suppressions.push(Date.now() + SUPPRESS_TTL);
  //   },
  //   true
  // );

  // document.addEventListener(
  //   'cart:refresh',
  //   function (event) {
  //     var detail = event.detail;

  //     if (!detail || !detail.openMiniCart) return;

  //     var now = Date.now();
  //     while (suppressions.length && suppressions[0] < now) {
  //       suppressions.shift();
  //     }

  //     if (!suppressions.length) return;

  //     suppressions.shift();
  //     detail.openMiniCart = false;
  //   },
  //   true
  // );

  function reconcile() {
    if (reconciled) {
      return;
    }

    reconciled = true;

    var run = function () {
      fetchCart()
        .then(ingest)
        .catch(function () {});
    };

    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 300);
    }
  }

  function findLines(variantId) {
    if (!cart || !cart.items || !variantId) {
      return [];
    }

    return cart.items.filter(function (item) {
      if (item.variant_id !== variantId) {
        return false;
      }

      var properties = item.properties || {};

      return !Object.keys(properties).some(function (key) {
        return key.charAt(0) === '_';
      });
    });
  }

  //returns the total quantity of a variant in the cart.
  function totalQuantity(lines) {
    return lines.reduce(function (sum, line) {
      return sum + line.quantity;
    }, 0);
  }

  var queue = Promise.resolve();

  //Enqueue all stepper writes so that data don't get lost with multipe writes
  function enqueue(task) {
    //each tesk is calling writeQuantity.
    var result = queue.then(task, task);

    queue = result.catch(function () {});

    return result;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) {
          throw new Error(payload.description || payload.message || 'Cart update failed');
        }

        return payload;
      });
    });
  }

  //updates cart stepper qunitity and dispatches cart:updated and cart:refresh events to update the mini-cart section in the cart.liquid file.
  function announce(nextCart) {
    setCart(nextCart);

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:updated', { bubbles: true, detail: { cart: nextCart } })
    );

    // A stepper write opens the cart drawer, same as an add to cart does.
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: nextCart, openMiniCart: shouldOpenDrawer() }
      })
    );
    return nextCart;
  }

  /* Open only a closed drawer. openMiniCart makes sections/mini-cart.liquid swap
     the whole drawer and open it; when the drawer is already showing (a second
     write, or a reduce spread over several lines) false lets it morph the
     contents in place instead. Mirrors the theme: only when the cart is a drawer. */
  function shouldOpenDrawer() {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    if (settings.cartType !== 'drawer') return false;

    var drawer = document.getElementById('mini-cart');
    return !!drawer && !drawer.hasAttribute('open');
  }


  // handles quntity stepper writes to the cart. It will either add or remove items from the cart to reach the target quantity.
  function writeQuantity(variantId, lines, target) {
    var delta = target - totalQuantity(lines);

    if (delta === 0) {
      return Promise.resolve(null);
    }
    //rendeing the mini-cart section after modifying the cart. The mini-cart section is rendered in the cart.liquid file.
    //we can avoid rendering the mini-cart theme.js will evaluale calls ajax to render cart-mini section after cart-update event.
    if (delta > 0) {
      return post(ADD_URL + '.js', {
        id: variantId,
        quantity: delta,
        sections: 'mini-cart'
      }).then(function (added) {
        // /cart/add.js returns the added lines, not the cart, so read the cart back.
        return fetchCart().then(
          function (nextCart) {
            nextCart.sections = added.sections;

            return announce(nextCart);
          },
          function (error) {
            //if fetchCart fails then stale set to true because of oldCart state which we don't want to use
            stale = true;
            throw error;
          }
        );
      });
    }

    return reduceTo(variantId, target, lines.length + 2);
  }


  function reduceTo(variantId, target, budget) {
    var lines = findLines(variantId);
    var total = totalQuantity(lines);

    // `budget` stops a server that will not shrink the line from looping forever.
    if (total <= target || !lines.length || budget <= 0) {
      return Promise.resolve(null);
    }

    var last = lines[lines.length - 1];
    var take = Math.min(last.quantity, total - target);

    return post(CHANGE_URL + '.js', {
      id: last.key,
      quantity: last.quantity - take,
      sections: 'mini-cart'
    })
      .then(announce)
      .then(function () {
        return reduceTo(variantId, target, budget - 1);
      });
  }

  /* ------------------------------------------------------------------ *
   * Optimistic state, shared per variant
   *
   * Every stepper showing the same variant (PDP inline button, sticky bar,
   * cards) reads one pending quantity and one busy flag, so a tap on any of
   * them dims and updates all of them at once instead of only the one tapped.
   * ------------------------------------------------------------------ */

  // variantId -> quantity shown while a write is queued or in flight.
  var pendingByVariant = {};
  // variantId -> true while that variant has a write queued or in flight.
  var busyByVariant = {};
  // variantId -> debounce timer, so taps on different steppers coalesce too.
  var timerByVariant = {};

  function hasPending(variantId) {
    return Object.prototype.hasOwnProperty.call(pendingByVariant, variantId);
  }

  function stepTo(variantId, next) {
    pendingByVariant[variantId] = next;
    busyByVariant[variantId] = true;

    clearTimeout(timerByVariant[variantId]);
    //for fast tap, it merged into one request be tapper within write delay frame
    timerByVariant[variantId] = setTimeout(function () {
      flushVariant(variantId);
    }, WRITE_DELAY);

    publish();
  }

  function flushVariant(variantId) {
    delete timerByVariant[variantId];

    if (!hasPending(variantId)) {
      delete busyByVariant[variantId];
      publish();
      return;
    }

    var target = pendingByVariant[variantId];

    enqueue(function () {
      // A tap before the first reconcile lands (or after a failed read-back)
      // would otherwise diff against an empty/old cart and over-add.
      var ready = stale ? fetchCart().then(ingest) : Promise.resolve();

      return ready.then(function () {
        if (stale) {
          throw new Error('Could not read the cart');
        }

        // Re-read at execution time: earlier writes in the queue may have moved things.
        return writeQuantity(variantId, findLines(variantId), target);
      });
    })
      .catch(function (error) {
        console.error('[card-qty-stepper]', error);
        notifyError(error.message);
      })
      .then(function () {
        // Only release the optimistic value if nothing was tapped since.
        if (pendingByVariant[variantId] === target) {
          delete pendingByVariant[variantId];
          delete busyByVariant[variantId];
        }

        publish();
      });
  }

  function notifyError(message) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart-notification:show', {
        bubbles: true,
        detail: { status: 'error', error: message }
      })
    );
  }

  /* ------------------------------------------------------------------ *
   * Element
   * ------------------------------------------------------------------ */

  var CardQtyStepper = class extends HTMLElement {
    connectedCallback() {
      // Flickity and section rendering move nodes, which fires disconnect then
      // reconnect on the same element. Wire the DOM up once, or a second click
      // listener would double-count every tap.
      if (!this.initialized && !this.initialize()) {
        return;
      }

      if (subscribers.indexOf(this.onCartChanged) === -1) {
        subscribers.push(this.onCartChanged);
      }

      document.documentElement.addEventListener('variant:change', this.onVariantChanged);

      this.render();
      reconcile();
    }

    initialize() {
      this.control = this.querySelector('[data-stepper-control]');
      this.valueElement = this.querySelector('[data-stepper-qty]');
      this.decreaseButton = this.querySelector('[data-stepper-step="-1"]');
      this.increaseButton = this.querySelector('[data-stepper-step="1"]');

      if (!this.control || !this.valueElement || !this.decreaseButton || !this.increaseButton) {
        return false;
      }

      this.form = this.querySelector('form[action*="/cart/add"]');
      this.fallbackVariantId = parseInt(this.getAttribute('variant-id'), 10) || null;

      // What Liquid rendered. Until the first cart read lands, this is the only
      // quantity we have: computing from a null cart would give 0 and strip the
      // server's in-cart attribute, flashing the add to cart button back in.
      var seeded = parseInt(this.control.getAttribute('data-qty'), 10);

      this.seedQuantity = isNaN(seeded) ? 0 : seeded;
      this.seedVariantId = this.fallbackVariantId;

      var max = parseInt(this.getAttribute('max'), 10);
      this.max = isNaN(max) ? null : max;

      this.labels = {
        increase: this.getAttribute('label-increase') || 'Increase quantity',
        decrease: this.getAttribute('label-decrease') || 'Decrease quantity',
        remove: this.getAttribute('label-remove') || 'Remove',
        max: this.getAttribute('label-max') || 'No more stock'
      };

      // The optimistic quantity and busy flag live in pendingByVariant /
      // busyByVariant, shared with every other stepper on the same variant.

      this.onCartChanged = this.render.bind(this);
      this.onVariantChanged = this.onVariantChanged.bind(this);

      this.control.addEventListener('click', this.onClick.bind(this));

      this.initialized = true;

      return true;
    }

    disconnectedCallback() {
      var index = subscribers.indexOf(this.onCartChanged);

      if (index > -1) {
        subscribers.splice(index, 1);
      }

      document.documentElement.removeEventListener('variant:change', this.onVariantChanged);
    }

    /**
     * Read the variant live from the form, so a variant picker switching the
     * hidden input (PDP sticky bar, card variant popup) moves the stepper with it.
     */
    get variantId() {
      var input = this.form && this.form.querySelector('[name="id"]');
      var fromInput = input && parseInt(input.value, 10);

      return fromInput || this.fallbackVariantId;
    }

    get cartQuantity() {
      if (cart === null) {
        // No cart read yet. Trust the server's count, but only while the card
        // still points at the variant it was rendered for.
        return this.variantId === this.seedVariantId ? this.seedQuantity : 0;
      }

      return quantities[this.variantId] || 0;
    }

    get quantity() {
      var variantId = this.variantId;

      return hasPending(variantId) ? pendingByVariant[variantId] : this.cartQuantity;
    }

    onVariantChanged() {
      // Pending state is keyed by variant, so the stepper simply shows the new
      // variant's state. A write already queued for the old one still lands.
      this.render();
    }

    //listerns on the stepper click
    onClick(event) {
      var button = event.target.closest('[data-stepper-step]');

      if (!button || button.disabled) {
        return;
      }

      event.preventDefault();

      var current = this.quantity;
      var next = current + parseInt(button.getAttribute('data-stepper-step'), 10);

      if (next < 0 || (next > current && this.max !== null && current >= this.max)) {
        return;
      }

      // Shared per variant: every stepper on this variant updates and dims now.
      stepTo(this.variantId, next);
    }

    render() {
      if (!this.initialized) return;

      // Before the unchanged-quantity early return: busy can flip on its own
      // (a write finishing with the same number it started from).
      this.toggleAttribute('busy', !!busyByVariant[this.variantId]);

      var quantity = this.quantity;

      if(quantity===this.renderedQuantity) return;

      this.renderedQuantity = quantity;

      this.toggleAttribute('in-cart', quantity > 0);
      this.control.setAttribute('data-qty', String(quantity));

      if (quantity < 1) {
        return;
      }

      this.valueElement.textContent = quantity;

      var atMax = this.max !== null && quantity >= this.max;

      this.increaseButton.disabled = atMax;
      this.increaseButton.setAttribute(
        'aria-label',
        atMax ? this.labels.max : this.labels.increase
      );
      this.decreaseButton.setAttribute(
        'aria-label',
        quantity === 1 ? this.labels.remove : this.labels.decrease
      );
    }
  };

  if (!window.customElements.get('card-qty-stepper')) {
    window.customElements.define('card-qty-stepper', CardQtyStepper);
  }
})();
